import React from 'react';
import ContentNavi from "./contentNavi";
import Content from "./contentItems";
import Video from "./video";
import { Helmet } from 'react-helmet-async';
import layout from "./layout";
import text from "./text";



var defaultContent = {};
var renderedLang = 'de';

function createMetaContent(headTags){
  let headJSX = [];
  for(let tag in headTags){
    var TagName = tag;
    if(typeof headTags[tag] === 'string'){
      //title tag is just a string and has no attributes
      headJSX.push(<TagName key="title">{headTags[tag]}</TagName>);
    }else{
      //all other headTags have attributes but no text
      headTags[tag].forEach(function(tagsTag,i){
        tagsTag.key = tag+i;
        headJSX.push(
          <TagName {...tagsTag} />
        );
      });


    }
  }
  return headJSX;
}

export default class RenderContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: []
    };
  }

  loadDefaultContent = (newContent,cb) => {
    fetch("content.json")
      .then(res => res.json())
      .then(
        (result) => {
          defaultContent = result;
          cb(newContent);
        }
      )
  }


  setContent = (result) => {
    //overwrite with english translation
    for(const key in defaultContent){
      const section = defaultContent[key];
      if(Array.isArray(section)){
        section.map((item,i) =>{
          for(const vk in item){
            if(result[key][i][vk] === undefined){
              result[key][i][vk] = item[vk];
            }
          }
          return null;
        });
      }
    }
    renderedLang = this.props.lang;
    //console.log(result);
    this.setState({
      isLoaded: true,
      content: result
    });
  }

  //Load JSON from public folder
  componentDidMount(props) {
    //console.log("renderContent didMount");
    fetch(this.props.lang === 'de'?"content.json":"content-en.json")
      .then(res => res.json())
      .then(
        (result) => {
          if(this.props.lang === 'de'){
              defaultContent = result;
              this.setContent(result);
          }
          else if(!('Teaser' in defaultContent)){
            //no default content set
            this.loadDefaultContent(result,this.setContent);
          }else{
            //defalt content is already loaded
            this.setContent(result);
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }


  render() {
    if(renderedLang !== this.props.lang){
      this.componentDidMount(this.props);
    }
    const { error, isLoaded, content } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div><br /><br />Loading...</div>;
    } else {
      const getContent = (content) => {
        if(typeof content === 'string'){
          return content;
        }
        return content.text || content.img;
      }
      const getStyle = (content) => {
        if(typeof content === 'string'){
          return {};
        }
        return content.style;
      }
      return (
        <layout.ContentWrap>
          {content.head !== undefined &&
            <Helmet>
                {createMetaContent(content.head)}
            </Helmet>
          }
          <layout.TeaserWrap wrapImg={getContent(content.Teaser.kogge)} style={getStyle(content.Teaser.kogge)}>
            <layout.Teaser teaserImg={getContent(content.Teaser.taucher)} style={getStyle(content.Teaser.taucher)} />
          </layout.TeaserWrap>
          <text.H1 dangerouslySetInnerHTML={{__html: content.Teaser.H1}} />
          <layout.WhiteBar />
          <text.H2 dangerouslySetInnerHTML={{__html: content.Teaser.H2}} />
          {content.interimsContent !== undefined &&
            <div dangerouslySetInnerHTML={{__html: content.interimsContent}} />
          }
          {content.interimsContent === undefined &&
            <div>
              {content.Intro.Video !== undefined &&
                <Video vid={content.Intro.Video} poster={content.Intro.videoPoster} />
              }
              <br /><br />
              <div dangerouslySetInnerHTML={{__html: content.Intro.text}} />
            </div>
          }
          <ContentNavi items={content.vitrinen} interimsContent={content.interimsContent !== undefined} />
          {content.interimsContent === undefined &&
            <div>
              <br /><br />
              <div dangerouslySetInnerHTML={{__html: content.Middle.text}} />
              <Content items={content.vitrinen} Antwort={this.props.lang==='de'?'Antwort':'Answer'} notReadyContent={content.notReadyContent} />
            </div>
          }
          <br />
          <layout.WhiteBar />
          <div style={{fontWeight:'normal'}} dangerouslySetInnerHTML={{__html: content.links}} />
          <div style={{fontWeight:'normal'}} dangerouslySetInnerHTML={{__html: content.credits}} />
        </layout.ContentWrap>
      );
    }
  }
}
